import Image from "next/legacy/image";
import useSWR, { SWRConfig } from "swr";

import HomeHeader from "@/components/home/HomeHeader";
import ArticleCard from "@/components/article/ArticleCard";
import { fetchGraphql } from "@/utils/query";

import SeoLinks from "@/components/home/SeoLinks";
import HomeFooter from "@/components/home/HomeFooter";

import Breadcrumbs from "@/components/common/Breadcrumbs";
import { imageLoader } from "@/utils/image";

const fetcher = (url) => fetch(url).then((res) => res.json());

const ArticlePage = ({ fallback }) => {
    return (
        <SWRConfig value={{ fallback }}>
            <ArticlePageWithInitialData />
        </SWRConfig>
    );
};

const ArticlePageWithInitialData = () => {
    const { data } = useSWR("/api/article/memory-care", fetcher);

    return (
        <div className="h-screen bg-gray-50">
            <HomeHeader fixed />

            <div className="container mx-auto pt-16 sm:pt-20 pb-4 px-16">
                <Breadcrumbs
                    links={[
                        { name: "Resources", href: "/resources" },
                        { name: "Articles", href: "/resources/articles" },
                        {
                            name: "Memory Care",
                            href: "/resources/articles/memory-care",
                        },
                    ]}
                />
            </div>

            <div className="">
                <div className="hidden sm:block relative w-full h-40 sm:h-96 bg-black">
                    <Image
                        loader={imageLoader}
                        src="https://cdn.purpledoorfinders.com/purpledoorfinders/purpledoorfinders-articles"
                        alt="purple-door-finders-articles-for-memory-care"
                        layout="fill"
                        objectFit="cover"
                        objectPosition="0px -200px"
                        priority
                        unoptimized={false}
                        className="opacity-80"
                    />

                    <div className="flex justify-center">
                        <h1 className="absolute px-8 top-12 sm:top-48 text-3xl sm:text-5xl text-white font-headline font-bold">
                            Articles for Memory Care
                        </h1>
                    </div>
                </div>

                <div className="container mx-auto my-12 px-4 sm:px-16">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                        {data.map((article) => (
                            <ArticleCard
                                key={article.articleId}
                                article={article}
                                imageHeight="h-40 xl:h-48"
                            />
                        ))}
                    </div>
                </div>
            </div>

            <SeoLinks />
            <HomeFooter />
        </div>
    );
};

export const getStaticProps = async () => {
    const result = await fetchGraphql(`
        query {
            articles {
                articleId
                _createdAt
                _updatedAt
                type
                title
                date
                description
                mainImageUrl
                keywords
                topic
                author_link {
                    name
                }
            }
        }
    `);

    return {
        props: {
            fallback: {
                "/api/article/memory-care":
                    result.data.articles && result.data.articles.length > 0
                        ? result.data.articles
                              .filter((r) => r.type && r.type.includes("MC"))
                              .sort(
                                  (a, b) => new Date(b._createdAt) - new Date(a._createdAt)
                              )
                        : [],
            },
        },
    };
};

export default ArticlePage;
